export const getCurrentOrigin = (): string | undefined => {
	if (typeof window === 'undefined') {
		return;
	}
	try {
		return window.origin;
	} catch {
		return undefined;
	}
};
